import { render, staticRenderFns } from "./SmartErase.vue?vue&type=template&id=b209cc78&scoped=true"
import script from "./SmartErase.vue?vue&type=script&lang=js"
export * from "./SmartErase.vue?vue&type=script&lang=js"
import style0 from "./SmartErase.vue?vue&type=style&index=0&id=b209cc78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_f5b883aeb3d125b1f29ae1b8ca7c56aa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b209cc78",
  null
  
)

export default component.exports